/** Shared Select option presets for admin/customer panel forms and filters. */

export type SelectOption = { value: string; label: string };

export const VISIBILITY_OPTIONS: SelectOption[] = [
  { value: '1', label: 'ظاهر / مفعّل' },
  { value: '0', label: 'مخفي / معطّل' },
];

export const VISIBILITY_FILTER_OPTIONS: SelectOption[] = [
  { value: 'all', label: 'الكل' },
  { value: 'active', label: 'الظاهرة / المفعّلة' },
  { value: 'hidden', label: 'المخفية / المعطّلة' },
];

export const COMPANY_OPTIONS: SelectOption[] = [
  { value: 'syriatel', label: 'سيريتل' },
  { value: 'mtn', label: 'MTN' },
];

export const COMPANY_FILTER_OPTIONS: SelectOption[] = [
  { value: 'all', label: 'كل الشبكات' },
  ...COMPANY_OPTIONS,
];

export const SOURCE_PROVIDER_OPTIONS: SelectOption[] = [
  { value: 'sham_balance', label: 'Sham Balance' },
  { value: 'kazeti_ussd', label: 'USSD' },
  { value: 'api_syria', label: 'API Syria' },
];

/** Providers selectable per telecom service (company × kind). */
export const SERVICE_SOURCE_PROVIDER_OPTIONS: SelectOption[] = [
  { value: 'sham_balance', label: 'Sham Balance' },
  { value: 'kazeti_ussd', label: 'USSD' },
  { value: 'api_syria', label: 'API Syria' },
];

export const SOURCE_PROVIDER_FILTER_OPTIONS: SelectOption[] = [
  { value: 'all', label: 'كل المصادر' },
  ...SOURCE_PROVIDER_OPTIONS,
];
